<template>
  <b-collapse v-model="showFilters">
    <div class="well well-filter" style="margin-bottom: 30px">
      <div class="form-group">
        <div class="row">
          <div class="col-xs-12 col-sm-6 col-md-4">
            <div class="filter-heading">Sort</div>
            <div class="filter-input-margin">
              <label class="form-label form-label-filter" for="FilterSort"
                >Sort by</label
              >
              <template v-if="sortOptions && sortOptions.length > 0">
                <b-multi-select
                  v-model="selectedSortOrder"
                  :options="sortOptions"
                  :limit="1"
                  class="multi-select"
                  placeholder="Sort by"
                  block
                />
              </template>
            </div>
          </div>
          <template v-if="filterOptions">
            <div class="col-xs-12 col-sm-12 col-md-8">
              <div class="filter-heading">Filter</div>
              <div class="row">
                <template>
                  <div
                    div
                    class="col-xs-12 col-sm-6 col-md-6 filter-input-margin"
                  >
                    <label
                      class="form-label form-label-filter"
                      for="searchTerm"
                      >Search project title or client</label
                    >
                    <input
                      v-model="selectedFilters.searchTerm"
                      type="text"
                      class="form-control"
                      placeholder="Search"
                    />
                  </div>
                </template>
                <template
                  v-if="
                    filterOptions.regions && filterOptions.regions.length > 0
                  "
                >
                  <div
                    div
                    class="col-xs-12 col-sm-6 col-md-6 filter-input-margin"
                  >
                    <label
                      class="form-label form-label-filter"
                      for="FilterRegions"
                      >Countries</label
                    >
                    <b-multi-select
                      v-model="selectedFilters.regions"
                      :options="filterOptions.regions"
                      class="multi-select"
                      placeholder="Countries"
                      filterable
                      block
                      collapse-selected
                    />
                  </div>
                </template>

								<template>
									<div class="col-xs-12 col-sm-6 col-md-6 filter-input-margin">
										                    <label
                      class="form-label form-label-filter"
                      for="dateFrom"
                      >Completion date from</label
                    >
										<input
											v-model="selectedFilters.dateFrom"
											filterable
											block
											collapse-selected
											type="date" id="date-1" class="form-control ">
									</div>
								</template>
								<template>
									<div class="col-xs-12 col-sm-6 col-md-6 filter-input-margin">
										                    <label
                      class="form-label form-label-filter"
                      for="dateTo"
                      >Completion date to</label
                    >
										<input
											v-model="selectedFilters.dateTo"
											filterable
											block
											collapse-selected
											type="date" id="date-2" class="form-control ">
									</div>
								</template>
              </div>

            </div>
          </template>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-6 col-sm-offset-6">
            <div class="filter-well-btn-bottom">
              <div class="row">
                <div class="col-xs-6">
                  <b-btn
                    class="btn btn-primary btn-sm btn-block"
                    @click="resetFilters"
                    >Reset</b-btn
                  >
                </div>
                <div class="col-xs-6">
                  <b-btn
                    class="btn btn-secondary btn-sm btn-block"
                    @click="applyFilters"
                    >Submit</b-btn
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-collapse>
</template>

<script>
export default {
	props: {
		showFilters: {
			type: Boolean,
			required: true,
		},
		filterOptions: {
			type: Object,
			default: () => [],
		},
		sortOptions: {
			type: Array,
			default: () => [],
		},
		selectedFilters: {
			clients: {
				type: Array,
				default: () => [],
			},
	  searchTerm: {
		  default: () => '',
	  },
			regions: {
				type: Array,
				default: () => [],
			},
			status: {
				type: Array,
				default: () => [],
			},
			tags: {
				type: Array,
				default: () => [],
			},
			dates: {
				type: Array,
				default: () => [],
			},
		},
	},
	data() {
		return {
			selectedSortOrder: [],
		};
	},
	methods: {
		resetFilters() {
			this.$emit('selectedOptions', {
				selectedSortOrder: [],
				selectedFilters: {
					searchTerm: '',
					clients: [],
					status: [],
					regions: [],
					tags: [],
					dates: [],
					dateFrom: '',
					dateTo: '',
				},
			});
			this.$emit('resetSearchTerm');
			this.$router.push({
				query: null,
			});
		},
		applyFilters() {
			this.$emit('selectedOptions', {
				searchTerm: this.selectedFilters.searchTerm,
				selectedSortOrder: this.selectedSortOrder[0] || null,
				selectedFilters: this.selectedFilters,
			});
		},
	},
};
</script>
